<div class="spinner ion-padding ion-text-center" [ngClass]="'spinner--' + size">
  <ion-spinner [name]="type" [color]="color"></ion-spinner>
  <p *ngIf="!!message">
    <ion-text [color]="color">
      {{ message | translate }}
    </ion-text>
  </p>
</div>